export default "__VITE_ASSET__CBvSIAJR__"